import {
  LoginContainer,
  // SignUpContainer,
  // OTPContainer,
  // ForgetPasswordContainer,
  // ResetPasswordContainer,
  // OnboardingContainerOne,
  // OnboardingContainerTwo,
  // AppHomeContainer,
  // WalletContainer,
  // CheckoutContainer,
  // ProductCheckOutFilledContainer,
  // ProductDisplayContainer,
  // ProductCheckOutContainer,
  // MimaCheckoutContainer,
  // PaymentLinkCheckoutContainer,
} from "../containers";

import PasswordChangeSuccess from "../pages/ResetPassword/PasswordChangeSuccess";
import Error404 from "../pages/Error/Error404";
import constant from "../utils/constant";
import RoughSketch from "../pages/RoughSketch";

const openRoutes = [
  {
    path: constant.Routes.Home,
    element: <LoginContainer />,
  },
  {
    path: constant.Routes.Login,
    element: <LoginContainer />,
  },

  {
    path: "/rough",
    element: <RoughSketch />,
  },
];

export default openRoutes;
